export enum TagsType {
  Trigger,
  Template,
  Code,
  Inquiry
}
